export default "__VITE_PUBLIC_ASSET__39e8d1c8__"